import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerGroupsStateModule } from './+state/customer-groups.state.module';
import { CustomerGroupsService } from './services';
import { CustomerGroupsFacade } from './+state';

@NgModule({
  imports: [CommonModule, CustomerGroupsStateModule],
})
export class DomainCustomerGroupsModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainCustomerGroupsModule,
      providers: [CustomerGroupsService, CustomerGroupsFacade],
    };
  }
}
